import { ErrorLayout } from '@/components/layouts/ErrorLayout';
import { useNavigateToHome } from '@/hooks/useNavigateToHome';

export const NotFound = () => {
  const { navigateToHome } = useNavigateToHome();

  return (
    <ErrorLayout
      titleKey="errors.page.notFoundTitle"
      messageKey="errors.page.notFoundMessage"
      backButtonTextKey="errors.page.backToLogin"
      onBackClick={navigateToHome}
    />
  );
};
